export class AssociateCandidateDisplayQueryFilter {
    constructor() {
        this.searchText = "";
        this.score = "";
        this.numberOfDays = "";
        this.topMatches = "";
        this.lastModified = "";
        this.jobTypes = [];
        this.jobSubTypes = [];
        this.sponsorships = [];
        this.workLocationIds = [];
        this.salary = "";
        this.rate = "";
        this.selectedFilterSort = "";
        this.showCandidateDisplayFilterIcon = true;
    }
}
//# sourceMappingURL=associateCandidateDisplayQueryFilter.js.map